<template>

    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=''"/>

    <div class="related-news" v-if="adminDetails || relatedPosts">
        <div id="author-details" class="container-size-fixer">
            <div id="author-details-box" v-if="adminDetails">
                <div class="image-content">
                    <img v-if="adminDetails.file" width="45" height="45" :src="$store.state.base_urls.adminsUploads + adminDetails.file" :alt="adminDetails.name">
                    <img v-else width="45" height="45" src="../assets/defaults/man.jpg" alt="default-pic">
                    <div>{{adminDetails.name}}</div>
                </div>
                <div class="txt-content">
                    {{adminDetails.relatedPostsCount}} مطلب

                </div>
            </div>
        </div>
        <div id="main-text-content" class="container-size-fixer" v-if="adminDetails">
            <div class="title form-title" id="related-news-title">
                <ul>
                    <li>
                        <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                        مطالب نوشته شده توسط {{adminDetails.name}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="main-container related-articles-content row rtl-direction container-size-fixer" v-if="relatedPosts">
            <NewsView v-for="postInfo in relatedPosts" :postInfo="postInfo" :key="postInfo"/>
        </div>
        <div id="footer-btn">
            <a v-on:click="loadMoreRelatedArticles()"  v-if="moreDataExistence && loadingMoodMoreArticles==false">
                بارگذاری مقالات بیشتر
            </a>
            <img  v-else-if="loadingMoodMoreArticles" style="height: auto;width: 20%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
    </div>
    <div  class="related-news" v-if="loadingMood">
        <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
    </div>
</template>

<script>
    import NewsView from '../components/NewsView'
    import axios from 'axios'
    import Alert from "../components/Alert"
    export default {
        name: "AuthorPage",
        data() {
            return {
                alertContent: null,
                loadingMood: false,
                relatedPosts: null,
                adminDetails: null,
                moreDataExistence : false,
                loadingMoodMoreArticles : false,
                username:this.$route.params.username,
            }
        },
        components:{
            NewsView,
            Alert
        },
        methods: {
            async loadMoreRelatedArticles() {
                try {
                    this.loadingMoodMoreArticles = true;
                    let response = await axios.get('api/loadMoreAuthorRelatedArticles/' + this.adminDetails.username + '/' +this.relatedPosts[this.relatedPosts.length-1].slug);
                    this.loadingMoodMoreArticles = false;
                    if(response.data.results.relatedPosts!=null){
                        this.relatedPosts = this.relatedPosts.concat(response.data.results.relatedPosts);
                        this.moreDataExistence = response.data.results.moreDataExistence;
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getRelatedArticles() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getAuthorRelatedArticles/' + this.username);
                    this.loadingMood = false;
                    this.relatedPosts = response.data.results.relatedPosts;
                    this.adminDetails = response.data.results.adminDetails;
                    this.moreDataExistence = response.data.results.moreDataExistence;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getRelatedArticles();
        },
        watch: { $route(to, from) { if(to !== from){ this.username = this.$route.params.username; this.getRelatedArticles() } } }
    }
</script>

<style lang="scss"  scoped>
    .txt-content{
        text-align: left;
        display: flex;
        width: max-content;
        height: 50px;
        align-items: center;
        justify-content: flex-end;
    }
    .image-content{
        text-align: right;
        width: max-content;
        height: 50px;
        display: flex;
        align-items: center;
        div{
            padding-right: 15px;
        }
        img{
            border-radius: 50%;
        }
    }
    #author-details{
        margin: auto;
        width: 100%;
        height: 46px;
        padding: 0 15px;
    }
    #author-details-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px  15px 15px 15px;
        width: 100%;
        height: auto;
        background-color:rgba(232, 232, 232, 0.5);
        border-radius: 10px;
    }

    .title{
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        ul{
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;

            li{

                padding: 5px;
                img{
                    margin-top: 5px;
                    width: 9px!important;
                    height: auto!important;
                }
                display: inline-block;
                span{
                    color: #cc171d;
                }
            }
        }

    }

    .form-title{
        ul{
            padding: 0;
        }
        font-size: 22px!important;
    }

    #footer-btn{
        width: 100%;
        font-size: 15px;
        color: rgba(26, 26, 26, 1);
        height: 112px;
        line-height: 112px;
    }

    .related-news{
        padding: 50px 0;
        width: 100%;
        height: auto;
        background-color: white;
    }
    .related-news-content{
        padding:15px!important; ;
    }

    #main-text-content{
        margin: auto;
        padding: 0 15px;
    }




    #direction>ul{
        padding: 0;
        text-align: right;
        list-style-type: none;
    }
    #direction>ul>li{
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction>ul>li:nth-child(3){
        opacity: 0.3;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }

    .main-container{
        max-width: 1120px;
        width: 100%;
        background-color: white!important;
        margin: auto;
        padding: 50px 15px;
    }
    #related-news-title{
        width: 100%;
        text-align: right!important;
        font-size: 20px!important;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        margin-top: 75px!important;
        span{
            color: #cc171d!important;
        }
    }
</style>